module.exports = __webpack_public_path__ + "img/matrix-integrations-en-us.87332d57.jpg";